var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-rename", attrs: { id: "idPopupRename" } },
    [
      _c("p", { staticClass: "modal-rename__label" }, [_vm._v("Rename")]),
      _vm._v(" "),
      _c(
        "b-form-group",
        [
          _c("j-input", {
            ref: "inputName",
            class: { "error-input": _vm.$v.name.$error },
            attrs: { placeholder: "Input name" },
            model: {
              value: _vm.name,
              callback: function($$v) {
                _vm.name = $$v
              },
              expression: "name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("div", { staticClass: "float-to-right" }, [
              _c(
                "button",
                {
                  staticClass: "button-border mr-2",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("\n          Cancel\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button-blue",
                  attrs: { type: "button" },
                  on: { click: _vm.handleRename }
                },
                [_vm._v("\n          Set\n        ")]
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-289ef953", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-289ef953","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/jPopupRename.vue
// module id = null
// module chunks = 